<!-- 邀请注册-常见问题 -->
<template>
  <div class="conBox dip fdcolmun">
    <div class="headBox dip fdcolmun">
      <div class="headBoxH3">{{ $fanyi("你有什么问题吗?") }}</div>
      <div class="headBoxH2">{{ $fanyi("常见问题") }}</div>
      <div class="headBoxCon">
        {{
          $fanyi(
            "查看Rakumart进口常见问题，了解你可享受的所有优势和保障。",
          )
        }}
      </div>
    </div>

    <div class="problemListBox">
      <foldingPanel>
        <template slot="title">
          <div>{{ $fanyi("什么是Rakumart？") }}</div>
        </template>

        <span class="problemItemConBx">{{
          $fanyi(
            "Rakumart是一个“一体化”的进口平台，将意大利用户与数千家中国供应商连接起来，以具有竞争力的价格提供产品。我们管理整个过程：采购，订单，质量检查，运输和售后服务，客户服务100%用意大利语。",
          )
        }}</span>
      </foldingPanel>

      <foldingPanel>
        <template slot="title">
          <div>{{ $fanyi("我们为哪些国家客户提供从中国进口商品的服务？") }}</div>
        </template>

        <span class="problemItemConBx">
          <div
            v-html="
              $fanyi(
                '在rakumart.it，我们只为意大利客户提供从中国进口商品的服务。我们还有rakumart.es、rakumart.us、rakumart.com等网站，您可以根据自己的需要进行选择。',
              )
            "
          ></div>
        </span>
      </foldingPanel>

      <foldingPanel>
        <template slot="title">
          <div>{{ $fanyi("需要账户才能下单吗？") }}</div>
        </template>

        <span class="problemItemConBx">
          {{
            $fanyi(
              "是的，你需要一个帐户。在rakumart.it免费注册，开始订购。有了您的帐户，您将能够访问有用的工具来管理和监控您的购买。此外，您的个人信息将被安全存储，使未来的订单更容易和快速。",
            )
          }}
        </span>
      </foldingPanel>

      <foldingPanel>
        <template slot="title">
          <div>{{ $fanyi("我们的服务面向谁？") }}</div>
        </template>

        <span class="problemItemConBx">
          {{
            $fanyi(
              "Rakumart 面向希望以具有竞争力的价格批量采购产品的企业、公司和自由职业者。我们提供个性化OEM服务，以满足具体需求，并支持客户发展壮大。",
            )
          }}
        </span>
      </foldingPanel>

      <foldingPanel>
        <template slot="title">
          <div>{{ $fanyi("Rakumart有什么优势？") }}</div>
        </template>

        <span class="problemItemConBx">
          {{
            $fanyi(
              "Rakumart以具有竞争力的价格提供产品，支持从多个经过验证的供应商处集中采购并合并为一次发货，有助于优化进口成本。服务包括意大利境内物流、质检、报关管理和客服支持，并提供意大利语支持。",
            )
          }}
        </span>
      </foldingPanel>

      <foldingPanel>
        <template slot="title">
          <div>{{ $fanyi("我们如何审核供应商？") }}</div>
        </template>

        <span class="problemItemConBx">
          {{
            $fanyi(
              "在Rakumart，我们通过严格的选择过程来保证我们供应商的质量和可靠性。我们评估产品、交货时间和沟通。凭借在中国、日本、韩国和巴西的经验，我们了解全球需求，并保持可靠供应商的最新数据库。此外，我们保持持续沟通，以确保质量标准得到满足.",
            )
          }}
        </span>
      </foldingPanel>
    </div>
  </div>
</template>
<script>
import foldingPanel from "./foldingPanel.vue";
export default {
  data() {
    return {};
  },
  components: {
    foldingPanel,
  },
  computed: {},
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";

.conBox {
  margin: 0 auto;
  padding: 115px 0;

  .headBox {
    text-align: center;
    margin: 0 auto 0;
    width: 920px;

    .headBoxH3 {
      color: var(--Rakumart-500, #009246);
      font-size: 20px;
      font-weight: 700;
      line-height: 30px;
      /* 150% */
      margin-bottom: 8px;
    }

    .headBoxH2 {
      color: #013b2d;
      font-size: 36px;
      font-weight: 600;
      line-height: 44px;
      /* 122.222% */
      letter-spacing: -0.72px;
      margin-bottom: 16px;
    }

    .headBoxCon {
      width: 830px;

      font-size: 18px;
      line-height: 28px;
      /* 155.556% */
      margin-bottom: 56px;
    }
  }

  .problemListBox {
    width: 1058px;

    .problemItemConBx {
      font-size: 18px;
      line-height: 28px;
      /* 155.556% */
      color: var(--Gray-600, #475467);
    }
  }
}
</style>
